<template>
  <div class="file-upload-section">
    <!-- Tab buttons for switching between methods -->
    <div class="upload-method-tabs">
      <button
        :class="['tab-button', {active: uploadMethod === 'file'}]"
        @click="uploadMethod = 'file'"
        style="font-size: 12px;"
        type="button"
      >
        Upload File
      </button>
      <button
        :class="['tab-button', {active: uploadMethod === 'url'}]"
        @click="uploadMethod = 'url'"
        style="font-size: 12px;"
        type="button"
      >
        Use URL
      </button>
    </div>

    <!-- File upload option -->
    <div v-if="uploadMethod === 'file'" class="upload-option">
      <input
        type="file"
        ref="fileInput"
        @change="handleFileUpload"
        accept="image/*"
        class="file-input"
        :id="id"
      />
      <label
        :for="id"
        class="btn btn-quaternary"
        style="border-radius: 4px;width: 100%;font-size: 14px;letter-spacing: 0px;"
      >
        Choose File
      </label>
    </div>

    <!-- URL input option -->
    <div v-if="uploadMethod === 'url'" class="upload-option">
      <div class="url-input-group">
        <input
          type="url"
          v-model="urlInput"
          placeholder="Enter image URL..."
          class="url-input"
        />
        <button
          class="btn btn-primary"
          style="border-radius: 4px;font-size: 14px;letter-spacing: 0px;"
          @click="updateImageFromUrl"
          type="button"
        >
          Save
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ChangeImageSection',
  props: ['id'],
  data() {
    return {
      uploadMethod: 'file', // 'file' or 'url'
      urlInput: '',
    };
  },
  methods: {
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        this.$emit('on-file-upload', {
          file: file,
        });
      }
    },
    updateImageFromUrl() {
      if (this.urlInput) {
        this.$emit('on-url-update', {
          url: this.urlInput,
        });
        this.urlInput = '';
      }
    },
  },
};
</script>

<style scoped>
.file-upload-section {
  width: 100%;
  max-width: 200px;
}

.upload-method-tabs {
  display: flex;
  border-bottom: 1px solid #dee2e6;
  margin-bottom: 12px;
}

.tab-button {
  flex: 1;
  padding: 8px 16px;
  background: none;
  border: none;
  cursor: pointer;
  font-size: 14px;
  color: #6c757d;
  border-bottom: 2px solid transparent;
  transition: all 0.2s ease;
}

.tab-button.active {
  color: #007bff;
  border-bottom-color: #007bff;
}

.tab-button:hover {
  background-color: #f8f9fa;
}

.upload-option {
  min-height: 40px;
}

.url-input-group {
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.url-input {
  flex: 1;
  padding: 8px 12px;
  border: 1px solid #ced4da;
  border-radius: 4px;
  font-size: 14px;
}

.url-input:focus {
  outline: none;
  border-color: #80bdff;
  box-shadow: 0 0 0 2px rgba(0, 123, 255, 0.25);
}

.file-input {
  display: none;
}
</style>
